import { IRootState } from '../../../store'
import { IPulsaraOptionsState } from '../store/options.types'

export const getPulsaraOptionsSelector = (state: IRootState): IPulsaraOptionsState => state.options.pulsaraOptions
